import { IEditModePayload, IModeCreate, IModeListSearch } from "../../../../types/master/modeInterface";
import api from "../../../../lib/api";

export const getModeListApi = async (data: IModeListSearch) => {
  return await api.get(`mode/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};

export const createModeApi = async (data: IModeCreate) => {
  return await api.post(`/mode`, data);
};

export const getModeDataByIdApi = async (id: number) => {
  return await api.get(`/mode/${id}`);
};

export const editModeDataByIdApi = async (payload: IEditModePayload) => {
  return await api.put(`/mode/${payload.id}`, payload.data);
};
